import {useEffect,useState} from 'react';
import {Link} from 'react-router';
import {registerCheckGaps,registerChecks,type RegisterCheck} from '@myfm/domain';
import {api} from '../api';
import {withBuildingScope} from '../ui/building-scope';

type Score={units:number;complete:number;percent:number;gaps:Record<RegisterCheck,number>};
/**
 * Priority 10 (20 Oct 2026): how complete this building's unit records are (owner, lease, service-charge share, contact,
 * records agreeing, checked), beside the information awaited, so cutover readiness is visible in one place. Read-only.
 */
export function BuildingRecordCompleteness({building}:{building:string}){
 const [score,setScore]=useState<Score|null>();
 useEffect(()=>{let active=true;setScore(undefined);
  void api<{score:Score}>(withBuildingScope(`/api/mobilisation/${building}/register-completeness`,building)).then(result=>{if(active)setScore(result.score)}).catch(()=>{if(active)setScore(null)});
  return()=>{active=false;};
 },[building]);
 if(!score)return null;
 const gaps=registerChecks.filter(check=>score.gaps[check]>0);
 return <section className="panel" aria-labelledby="record-completeness-heading"><h2 id="record-completeness-heading">Unit records</h2>
  {score.units===0?<p>No units are recorded for this building yet.</p>:<>
   <p><strong>{score.complete} of {score.units}</strong> {score.units===1?'unit has':'units have'} every record in place ({score.percent}% of all checks).</p>
   {gaps.length>0&&<ul>{gaps.map(check=><li key={check}>{score.gaps[check]} · {registerCheckGaps[check]}</li>)}</ul>}
  </>}
  <p><Link to={withBuildingScope('/contacts/register',building)}>Open the unit register</Link></p>
 </section>;
}
